import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Container, Row, Col } from "react-bootstrap";
import reactIcon from "../assets/img/react.png";
import htmlIcon from "../assets/img/html.png";
import cssIcon from "../assets/img/css.png";
import javascriptIcon from "../assets/img/javascript.png";
import bootstrapIcon from "../assets/img/bootstrap.png";
import javaIcon from "../assets/img/java.png";
import kotlinIcon from "../assets/img/kotlin.png";
import xmlIcon from "../assets/img/xml.png";
import pythonIcon from "../assets/img/python.png";
import AIIcon from "../assets/img/artificial-intelligence.png";
import MLIcon from "../assets/img/coding.png";
import TypescriptIcon from "../assets/img/typescript.svg";
import MongoDBIcon from "../assets/img/mongodb.svg";
import NodeJSIcon from "../assets/img/nodeJs.svg";
import FlaskIcon from "../assets/img/flask.svg";
import TailwindCSSIcon from "../assets/img/tailwindcss.svg";
import MaterialUIIcon from "../assets/img/materialui.svg";
import GoogleCloudIcon from "../assets/img/google-cloud.svg";
import SQLIcon from "../assets/img/sql.svg";
import FirebaseIcon from "../assets/img/firebase.svg";
export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col>
            <div className="skill-bx">
              <h2>Skills</h2>
              <p>Languages / Frameworks / Tools / Technologies</p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="skill-slider mt-5"
              >
                <div className="item">
                  <img src={reactIcon} alt="skill-img" />
                  <h5 className="mt-2">React</h5>
                </div>
                <div className="item">
                  <img src={TypescriptIcon} alt="skill-img" />
                  <h5 className="mt-2">Typescript</h5>
                </div>
                <div className="item">
                  <img src={NodeJSIcon} alt="skill-img" />
                  <h5 className="mt-2">Node JS</h5>
                </div>
                <div className="item">
                  <img src={MongoDBIcon} alt="skill-img" />
                  <h5 className="mt-2">Mongo-DB</h5>
                </div>
                <div className="item">
                  <img src={htmlIcon} alt="skill-img" />
                  <h5 className="mt-2">HTML</h5>
                </div>
                <div className="item">
                  <img src={cssIcon} alt="skill-img" />
                  <h5 className="mt-2">CSS</h5>
                </div>
                <div className="item">
                  <img src={javascriptIcon} alt="skill-img" />
                  <h5 className="mt-2">JavaScript</h5>
                </div>
                <div className="item">
                  <img src={TailwindCSSIcon} alt="skill-img" />
                  <h5 className="mt-2">Tailwindcss</h5>
                </div>
                <div className="item">
                  <img src={MaterialUIIcon} alt="skill-img" />
                  <h5 className="mt-2">Material UI</h5>
                </div>
                <div className="item">
                  <img src={bootstrapIcon} alt="skill-img" />
                  <h5 className="mt-2">Bootstrap</h5>
                </div>
                <div className="item">
                  <img src={javaIcon} alt="skill-img" />
                  <h5 className="mt-2">Java</h5>
                </div>
                <div className="item">
                  <img src={kotlinIcon} alt="skill-img" />
                  <h5 className="mt-2">Kotlin</h5>
                </div>
                <div className="item">
                  <img src={xmlIcon} alt="skill-img" />
                  <h5 className="mt-2">XML</h5>
                </div>
                <div className="item">
                  <img src={javaIcon} alt="skill-img" />
                  <h5 className="mt-2">Java Swing</h5>
                </div>
                <div className="item">
                  <img src={GoogleCloudIcon} alt="skill-img" />
                  <h5 className="mt-2">Google Cloud Compute Practioner</h5>
                </div>
                <div className="item">
                  <img src={SQLIcon} alt="skill-img" />
                  <h5 className="mt-2">SQL</h5>
                </div>
                <div className="item">
                  <img src={FirebaseIcon} alt="skill-img" />
                  <h5 className="mt-2">Firebase</h5>
                </div>
                <div className="item">
                  <img src={pythonIcon} alt="skill-img" />
                  <h5 className="mt-2">Python</h5>
                </div>
                <div className="item">
                  <img src={FlaskIcon} alt="skill-img" />
                  <h5 className="mt-2">Flask</h5>
                </div>
                <div className="item">
                  <img src={AIIcon} alt="skill-img" />
                  <h5 className="mt-2">Artificial Intelligence</h5>
                </div>
                <div className="item">
                  <img src={MLIcon} alt="skill-img" />
                  <h5 className="mt-2">Machine Learning</h5>
                </div>
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
